import type {
  AdvertisingAdvisory,
  AmazonSearchTerm,
  DataSource,
  Finding,
  ImportProfile,
  ReportSet,
  ReportType,
  ReviewResponse,
  RunStatus,
  ValidationIssue,
  WeeklySummary,
} from "../../api/client";

export type FlowStep = "import" | "validation" | "running" | "summary";

export interface FlowState {
  step: FlowStep;
  profiles: ImportProfile[];
  sources: DataSource[];
  selectedSourceId: string;
  selectedProfileIds: Partial<Record<ReportType, string>>;
  periodStart: string;
  periodEnd: string;
  comparisonWindowWeeks: number;
  reportingCurrency: string;
  currencyRates: string;
  sourceVariants: Partial<Record<ReportType, string>>;
  files: Partial<Record<ReportType, File>>;
  reportSet: ReportSet | null;
  issues: ValidationIssue[];
  run: RunStatus | null;
  summary: WeeklySummary | null;
  findings: Finding[];
  searchTerms: AmazonSearchTerm[];
  advertisingAdvisory: AdvertisingAdvisory | null;
  selected: Finding | null;
  reviews: Record<string, ReviewResponse>;
  busy: boolean;
  error: string | null;
}

export const reportTypes: ReportType[] = ["sales_traffic", "advertising", "inventory_lead_time"];

export const reportLabels: Record<ReportType, string> = {
  sales_traffic: "销售与流量",
  advertising: "广告表现",
  inventory_lead_time: "库存与交期",
};
